var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 1.23408C12.4175 0.876579 11.84 0.876579 11.4825 1.23408L7.00003 5.70741L2.51753 1.22491C2.16003 0.867412 1.58253 0.867412 1.22503 1.22491C0.867534 1.58241 0.867534 2.15991 1.22503 2.51741L5.70753 6.99991L1.22503 11.4824C0.867534 11.8399 0.867534 12.4174 1.22503 12.7749C1.58253 13.1324 2.16003 13.1324 2.51753 12.7749L7.00003 8.29241L11.4825 12.7749C11.84 13.1324 12.4175 13.1324 12.775 12.7749C13.1325 12.4174 13.1325 11.8399 12.775 11.4824L8.29253 6.99991L12.775 2.51741C13.1234 2.16908 13.1234 1.58241 12.775 1.23408Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.ccded1a30c79a46e89358007786a2c93.svg";
export { ForwardRef as ReactComponent };